import { render, staticRenderFns } from "./OriginText.vue?vue&type=template&id=5390fe42&"
import script from "./OriginText.vue?vue&type=script&lang=js&"
export * from "./OriginText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports